import {all, fork, put, takeLatest} from 'redux-saga/effects';
import {
  createInvoiceSuccess,
  deleteInvoiceSuccess,
  getAllInvoicesSuccess,
  getInvoiceByAccessCodeSuccess,
  getInvoicesSuccess,
  getInvoiceStatusesSuccess,
  getInvoiceSuccess,
  setLoadingInvisible,
  setLoadingVisible,
  updateInvoiceSuccess,
} from 'redux/actions';
import {
  INVOICES_ALL,
  INVOICES_CREATE,
  INVOICES_DELETE,
  INVOICES_GET,
  INVOICES_GET_ACCESS_CODE,
  INVOICES_GET_ALL,
  INVOICES_STATUSES,
  INVOICES_UPDATE,
} from 'redux/constants/Invoices';
import EstService from 'services/EstService';
import NotificationService from 'services/NotificationService';

export function* getInvoices() {
  yield takeLatest(
    INVOICES_ALL,
    function* ({ perPage, page, startDate, endDate, statusId }) {
      try {
        const res = yield EstService.getInvoices(
          perPage,
          page,
          startDate,
          endDate,
          statusId
        );

        const skip = perPage * (page - 1);
        const from = skip + 1;
        const to =
          skip + perPage > res.data.total ? res.data.total : skip + perPage;
        yield put(getInvoicesSuccess(res.data.data, res.data.total, from, to));
      } catch (err) {
        console.log(err);
      }
    }
  );
}

export function* getInvoice() {
  yield takeLatest(INVOICES_GET, function* ({ id }) {
    try {
      const res = yield EstService.getInvoice(id);
      yield put(getInvoiceSuccess(res.data));
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getInvoiceByAccessCode() {
  yield takeLatest(INVOICES_GET_ACCESS_CODE, function* ({ id, accessCode }) {
    try {
      const res = yield EstService.getInvoiceByAccessCode(id, accessCode);
      yield put(getInvoiceByAccessCodeSuccess(res.data));
    } catch (err) {
      console.log(err);
      NotificationService.error('There was a problem while getting invoice.');
    }
  });
}

export function* getAllInvoices() {
  yield takeLatest(INVOICES_GET_ALL, function* () {
    try {
      // For now there is no current way to obtain all the invoices from the API without this.
      // Providing 9999999 as the number of items per page while other endpoint
      // is developed.
      const res = yield EstService.getInvoices(9999999, 1);
      yield put(getAllInvoicesSuccess(res.data.data, res.data.total));
    } catch (err) {
      console.log(err);
    }
  });
}

export function* createInvoice() {
  yield takeLatest(INVOICES_CREATE, function* ({ data, history }) {
    try {
      const tag = yield EstService.createInvoice(data);
      yield put(createInvoiceSuccess(tag.data));
      history.push(`/app/invoices/${tag.data.account_invoice_id}`);
    } catch (err) {
      console.log(err);
    }
  });
}

export function* updateInvoice() {
  yield takeLatest(INVOICES_UPDATE, function* ({ id, data, history }) {
    try {
      const tag = yield EstService.updateInvoice(id, data);
      yield put(updateInvoiceSuccess(id, tag.data));
      if (history) {
        history.push(`/app/invoices/${id}`);
      }
    } catch (err) {
      console.log(err);
    }
  });
}

export function* deleteInvoice() {
  yield takeLatest(INVOICES_DELETE, function* ({ id, history }) {
    try {
      yield put(setLoadingVisible());
      const res = yield EstService.deleteInvoice(id);
      yield put(deleteInvoiceSuccess(id));
      if (res && res.message) {
        NotificationService.success(res.message);
      }
      if (history) {
        history.push(`/app/invoices`);
      }
      yield put(setLoadingInvisible());
    } catch (err) {
      console.log(err);
      yield put(setLoadingInvisible());
    }
  });
}

export function* getInvoiceStatuses() {
  yield takeLatest(INVOICES_STATUSES, function* () {
    try {
      const res = yield EstService.getInvoiceStatuses();
      yield put(getInvoiceStatusesSuccess(res.data));
    } catch (err) {
      console.log(err);
    }
  });
}

export default function* invoicesSaga() {
  yield all([
    fork(getInvoices),
    fork(getAllInvoices),
    fork(createInvoice),
    fork(getInvoice),
    fork(getInvoiceByAccessCode),
    fork(updateInvoice),
    fork(deleteInvoice),
    fork(getInvoiceStatuses),
  ]);
}
